<template>
  <b-col sm="6" md="4" lg="2" xl="3" class="my-2">
    <div class="item">
      <div class="titulo">
        <router-link tag="a" :to="link">{{ titulo }}</router-link>
      </div>
      <div class="passo passo_inativo mx-auto">
        <router-link tag="a" :to="link">
          <img :src="icone" alt="" v-b-tooltip.hover v-b-tooltip="tooltip" />
        </router-link>
      </div>

      <template v-if="quantidade != null">
        <div class="quantidade">
          CDA´s: {{quantidade}}
        </div>
      </template>
      <template v-else>
        <div class="quantidade">
          CDA´s: Carregando..
        </div>
      </template>

      <template v-if="exibirProcesso != null && processos != null">
        <div class="quantidade">
          Processos: {{processos}}
        </div>
      </template>
      <template v-if="exibirProcesso != null && processos == null">
        <div class="quantidade">
          Processos: Carregando..
        </div>
      </template>

      <template v-if="valor != null">
          <div class="valor">
            Valor: R$ {{valor | currency}}
          </div>    
      </template>
      <template v-else>
        <div class="valor">
          Valor: Carregando..  
        </div>
      </template>
    </div>
  </b-col>
</template>



<script>
export default {
  props: ["titulo", "icone", "link", "quantidade", "valor", "tooltip", "exibirProcesso", "processos"]
};
</script>



<style>

</style>


